import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { CustomerGroupDto } from '../dtos';

export class CustomerGroupsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public customerGroups: CustomerGroupDto[];
  public selectedCustomerGroup: CustomerGroupDto;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.customerGroups = null;
    this.selectedCustomerGroup = null;
  }
}
